export function mapDrugs(drugResultsArray) {
  return drugResultsArray.map((drug) => {
    return {
      title: drug.drugName,
      guideline: drug.guideline,
      summary: drug.fullText?.split(" - ")[1],
      url: drug.url,
    };
  });
}

function normalizeDrugIndexName(name) {
  return name.split(/\s[–-]\s/, 1)[0].trim();
}

export function summarizeDrugs(drugResultsArray) {
  const filteredDrugs = drugResultsArray.filter((drug) => {
    return drug.displayIndex;
  });
  const drugCounts = filteredDrugs.reduce((acc, drug) => {
    const name = drug.title || drug.drugName;
    if (!name) return acc;
    const normalizedName = normalizeDrugIndexName(name);
    if (!normalizedName) return acc;
    acc[normalizedName] = (acc[normalizedName] || 0) + 1;
    return acc;
  }, {});

  return Object.entries(drugCounts)
    .sort((a, b) => b[1] - a[1])
    .map(([name, count]) => ({ [name]: count }));
}
